// Sentry initialiser — no-ops when REACT_APP_SENTRY_DSN is unset.
// Set the env var in /app/frontend/.env to activate; restart the dev server.
import * as Sentry from "@sentry/react";

let _initialised = false;

export function initSentry() {
  if (_initialised) return;
  const dsn = (process.env.REACT_APP_SENTRY_DSN || "").trim();
  if (!dsn) return;
  try {
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_ENV || "production",
      release: process.env.REACT_APP_RELEASE || "glowup@2026.02",
      tracesSampleRate: 0.05,
      replaysOnErrorSampleRate: 0.1,
      replaysSessionSampleRate: 0,
      sendDefaultPii: false,
    });
    _initialised = true;
  } catch (e) {
    // Never let analytics break the app
    // eslint-disable-next-line no-console
    console.warn("Sentry init failed", e);
  }
}

export function captureException(err, context) {
  if (_initialised) {
    try {
      Sentry.withScope((scope) => {
        if (context) {
          Object.entries(context).forEach(([k, v]) => scope.setExtra(k, v));
        }
        Sentry.captureException(err);
      });
      return;
    } catch { /* fall through */ }
  }
  // eslint-disable-next-line no-console
  console.error("[unhandled]", err);
}
